import React from "react";
export var CartFooterMobileExtension = function CartFooterMobileExtension() {
  return React.createElement(React.Fragment, null, React.createElement("p", null, "mobile cart extension"));
};
CartFooterMobileExtension.displayName = "CartFooterMobileExtension";
export default CartFooterMobileExtension;